export enum PlatformCategory {
  'Авто и мото',
  'Бизнес и стартапы',
  'Видеоигры',
  'В мире животных',
  'Дети и родители',
  'Другое',
  'Еда и кулинария',
  'Здоровье и медицина',
  'Знаменитости и образ жизни',
  'Инвестиции',
  'Иностранные языки',
  'Интернет технологии',
  'Искусство и дизайн',
  'История',
  'Каталоги каналов и ботов',
  'Кино',
  'Книги, Аудиокниги и Подкасты',
  'Красота и уход',
  'Криптовалюты',
  'Культура и события',
  'Любопытные факты',
  'Маркетинг и PR',
  'Мода и стиль',
  'Мотивация и саморазвитие',
  'Музыка',
  'Наука и технологии',
  'Недвижимость',
  'Новости и СМИ',
  'Образование',
  'Отдых и развлечения',
  'Психология и отношения',
  'Путешествия и туризм',
  'Работа и вакансии',
  'Региональные',
  'Религия и духовность',
  'Скидки и акции',
  'Сливы Заработок',
  'Спорт',
  'Ставки и азартные игры',
  'Строительство и ремонт',
  'Трейдинг',
  'Узбекские каналы',
  'Фитнес',
  'Хобби и развлечения',
  'Экономика и Финансы',
  'Юмор и мемы',
  'Юриспруденция',
  '18+',
}
